"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toText = toText;
const Format_1 = require("../Format");
const subSuperscript_1 = require("./subSuperscript");
function toText(lines) {
    let text = [];
    for (let line of lines) {
        switch (line.kind) {
            case Format_1.Format.SUBSCRIPT: {
                const value = String(line.value);
                for (let i = 0; i < value.length; i++) {
                    const char = value[i];
                    if (subSuperscript_1.subscript[char]) {
                        text.push(subSuperscript_1.subscript[char]);
                    }
                    else {
                        throw new Error(`Subscript problem with: ${char}`);
                    }
                }
                break;
            }
            case Format_1.Format.SUPERSCRIPT: {
                const value = String(line.value);
                for (let i = 0; i < value.length; i++) {
                    const char = value[i];
                    if (subSuperscript_1.superscript[char]) {
                        text.push(subSuperscript_1.superscript[char]);
                    }
                    else {
                        throw new Error(`Superscript problem with: ${char}`);
                    }
                }
                break;
            }
            case Format_1.Format.SUPERIMPOSE: {
                const under = String(line.under);
                for (let i = 0; i < under.length; i++) {
                    const char = under[i];
                    if (subSuperscript_1.subscript[char]) {
                        text.push(subSuperscript_1.subscript[char]);
                    }
                    else {
                        throw new Error(`Subscript problem with: ${char}`);
                    }
                }
                const over = String(line.over);
                for (let i = 0; i < over.length; i++) {
                    const char = over[i];
                    if (subSuperscript_1.superscript[char]) {
                        text.push(subSuperscript_1.superscript[char]);
                    }
                    else {
                        throw new Error(`Superscript problem with: ${char}`);
                    }
                }
                break;
            }
            default:
                text.push(line.value);
        }
    }
    return text.join('');
}
//# sourceMappingURL=toText.js.map